<template>
  <collapsible-widget
    :collapsed="collapsed"
    :uuid="uuid"
    :title="title_component"
    icon="equalizer"
    colorBadge="info"
  >
    <div class="row">
      <div class="col-md-6">

        <table class="table m-auto">
          <tr>
            <th v-for="h in th" :key="h">{{ h }}</th>
          </tr>
          <tr v-for="flux in definitions" :key="`${flux}`">
            <th>{{ flux.attributes.name  }}</th>
            <td
              v-for="(col, j) in column_model"
              :key="`${j}-${col}`"
              :id="`${flux.attributes.name}`"
            ></td>
          </tr>
        </table>
      </div>
      <div v-if="img_side" class="col-md-6">
        <img
          :src="`${IREALCONFIG.static_ressources}/${img_side}.png`"
          alt="ireal scheme table indicator"
        />
      </div>
    </div>
  </collapsible-widget>
</template>

<script>
//  import componentMixin from "ireal-vue/mixins/component-mixin.js";
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import inputComponentMixin from "ireal-vue/mixins/input-component-mixin.js";
import collapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import httpService from "../services/http-service";
//import Bus from "../services/bus.js";

export default {
  name: "table-component",
  mixins: [dataComponentMixin, inputComponentMixin],
  components: { collapsibleWidget },
  data() {
    return {
      td_data: {},
      test: null,
    };
  },
  async created() {
    // we use httpMixin. request to have the list of experience. Fill array "experience" with results.
    this.definitions = this.config.elements;

  },
  async mounted() {
console.log(this.th);
console.log(this.definitions);
console.log(this.column_model);
},
  computed: {
    header() {
      return this.attributes.header ? this.attributes.header : "";
    },
    th() {
      if (this.attributes.column === undefined) return [];
      else return this.attributes.column_name.split("|");
    },
    td() {
      if (this.attributes.td === undefined) return [];
      else return this.attributes.td.split("|");
    },
    column_model() {
      if (this.attributes.column_model === undefined) return [];
      else return this.attributes.column_model.split("|");
    },
    defaultlist() {
      if (this.attributes.defaultlist === undefined) return [];
      else return this.attributes.defaultlist.split("|");
    },
    img_side() {
      return this.attributes.img_side;
    },
  },
  methods: {
    prepare() {},
    getIndexByValue(data) {
      return data.filter((data) => {
        return data.time < this.$store.getters.progress;
      });
    },
    tickFlux(data) {
      var lastIndex = this.getIndexByValue(data).pop();

      if (lastIndex) {
        var modelData = JSON.parse(lastIndex.raw_value);
        for (var model in this.td) {
          document.getElementById(`${this.td[model]}`).innerHTML =
            modelData[`${this.td[model]}`];
        }
      } else {
        for (var model in this.td) {
          document.getElementById(`${this.td[model]}`).innerHTML = "";
        }
      }
    },
    tick() {
      this.value = this.getDataForFlux(this.attributes.name).number_value;
      // Updates the DOM for each flux (rendering)

      let flux_structure = this.getFluxStructure(this.attributes.name);
      //console.log(this.timeStart, flux_structure.dataLoaded)
      this.tickFlux(flux_structure.data);
    },
    componentStartEvent() {
      const params = {
        params: this.$store.getters.testParams,
        flux_identifier: this.attributes.name,
        experience_id: this.$store.getters.experience.id,
        seed: this.$store.getters.seed,
      };
      this.getTimeData(params);
      // retourne toutes les promesses, lorsqu'elles sont toutes résolues. Sinon, le mounted subira une erreur au niveau du then
    },
  },
};
</script>
<style scoped>
tr:hover {
  background-color: #f8f8f8;
}
.d-flex {
  display: flex;
  width: 100%;
}
.justify-content-center {
  justify-content: center;
}

.button-container .mt-3 {
  margin-top: 3rem;
}
table {
  font-weight: 300 !important;
  font-size: 14px !important;
}
</style>


